/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.nikam-shreyas.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Link from "@mui/material/Link";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar";
import { Tooltip, IconButton, Icon, Grid } from "@mui/material";

import CrudService from "services/cruds-service";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { AuthContext } from "context";

// images for the meter
import meterHigh from "assets/images/meter-high.png";
import meterMid from "assets/images/meter-mid.png";
import meterLow from "assets/images/meter-low.png";

// tabs for the dashboard
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function JobsDashboard() {
  const { setIsAuthenticated, getCurrentUser } = useContext(AuthContext);
  const [jobs, setJobs] = useState([]);
  const [user, setUser] = useState({});

  // tab states
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);

  // function to get the jobs data for the particular user
  useEffect(() => {
    async function checkToken() {
      let user_id = await getCurrentUser();
      if (!user_id) {
        setIsAuthenticated(false);
        localStorage.removeItem("token");
      } else {
        setUser(user_id);
        return user_id;
      }
    }
    async function fetchJobsData(userId) {
      let response = await CrudService.getJobsByPersona(userId);
      setJobs(response);
    }
    checkToken().then((userId) => fetchJobsData(userId));
  }, []);

  const getJobs = (jobs) => {
    return jobs.map((job) => {
      return {
        _id: job._id,
        company: job.company,
        title: job.title,
        job_url: job.job_url,
        location: job.location,
        job_type: job.job_type,
        date_posted: job.date_posted,
        description: job.description.substring(0, 100) + "...",
        company_url: job.company_url, //combine url with company name (link?)
        logo_photo_url: job.logo_photo_url,
      };
    });
  };

  useEffect(() => {
    setTableData(getJobs(jobs));
  }, [jobs]);

  const clickExploreHandler = (id) => {
    navigate(`/jobs-dashboard/expanded-job/${id}`);
  };

  const dataTableData = {
    columns: [
      {
        Header: "company",
        accessor: "company",
        width: "15%",
        Cell: (info) => {
          return (
            <>
              <Grid container>
                <Grid item s={2}>
                  <MDAvatar
                    src={
                      // check if it is NaN
                      info.cell.row.original.logo_photo_url === "NaN"
                        ? "https://assets.procurement.opengov.com/assets/unknown-business-logo.png"
                        : info.cell.row.original.logo_photo_url
                    }
                    alt="company-logo"
                    size="sm"
                    shadow=""
                  />
                </Grid>
                <Grid item s={10} mt={1}>
                  <MDTypography
                    mt={2}
                    pt={2}
                    ml={2}
                    variant="text"
                  // onClick={() =>
                  //   window.open(info.cell.row.original.company_url, "_blank")
                  // }
                  >
                    {info.cell.row.original.company}
                  </MDTypography>
                </Grid>
              </Grid>
            </>
          );
        },
      },
      {
        Header: "title",
        accessor: "title",
        width: "15%",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              <Tooltip
                title="See job details"
                style={{
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
                onClick={(e) => clickExploreHandler(info.cell.row.original._id)}
              >
                <MDTypography variant="text" color="info">
                  {info.cell.row.original.title}
                </MDTypography>
              </Tooltip>
            </MDBox>
          );
        },
      },
      {
        Header: "location",
        accessor: "location",
        width: "15%",
        Cell: (info) => {
          return (
            <MDTypography variant="text" color="dark">
              {info.cell.row.original.location === "NaN"
                ? "United States"
                : info.cell.row.original.location}
            </MDTypography>
          );
        },
      },
      {
        Header: "QUSkillBridge Match Score",
        Cell: (info) => {
          return (
            <MDAvatar
              src={meterHigh}
              alt="skill-match-meter"
              size="s"
              shadow=""
            />
          );
        },
      },
    ],
    rows: tableData,
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={3} pb={3}>
        <MDBox mb={3}>
          <Card>
            <MDBox
              p={3}
              lineHeight={1}
              display="flex"
              justifyContent="space-between"
            >
              <MDTypography variant="h5" fontWeight="medium">
                New Jobs
              </MDTypography>
            </MDBox>
            <DataTable
              table={dataTableData}
              entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15, 20] }}
            />
          </Card>
        </MDBox>
      </MDBox>

    </DashboardLayout>
  );
}

export default JobsDashboard;
